import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { EntitiesList } from '../EntitiesList';
import { getUrlParams } from '../../utils';
import './sideNavStyles.scss';

export class SideNav extends Component {
  render() {
    const selectedItemId = get(this.props.selectedItem, 'id');
    const params = getUrlParams();

    return (
      <aside className="nx-side-nav__container app-side-nav">
        <div className="nx-side-nav nx-side-nav--has-applications nx-side-nav--open nx-side-nav--animated nx-side-nav--modern">
          <a href="/apps/home" className="nx-side-nav__logo">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NC45NiAyMy40OSI+PHBhdGggZD0iTTMzLjcyLS4wM2E0LjQgNC40IDAgMSAxLTQuNDIgNC40IDQuNDEgNC40MSAwIDAgMSA0LjQyLTQuNCIgZmlsbD0iI2VkYWUyYiIvPjxwYXRoIGQ9Ik04LjM2IDkuNzhIMHYxMy43aDMuOTRWMTIuNzJoMy40NGExLjQ3IDEuNDcgMCAwIDEgMS40OCAxLjQ3djkuM2gzLjk0di05LjNhNC40MiA0LjQyIDAgMCAwLTQuNDQtNC40MW00My4zMyAxMC43NmgtMi41OGExLjQ3IDEuNDcgMCAwIDEtMS4zNi0xLjQ3di02LjM2aDMuOTRWOS43N2gtMy45NFY0Ljg4aC0zLjk0djQuODloLTEuNzNsLTIuMjEgMi45NGgzLjk0djYuMzdhNC40MSA0LjQxIDAgMCAwIDQuNDIgNC40aDMuNDR2LTIuOTQiIGZpbGw9IiNmZmZmZmUiLz48cGF0aCBmaWxsPSIjZmZmZmZlIiBkPSJNNDEuMTIgOS43OGgtNC40NGwtMi45NSAzLjkyLTIuOTYtMy45MmgtNC40M2w1LjE3IDYuODQtNS4xNyA2Ljg2aDQuNDNsMi45Ni0zLjkyIDIuOTUgMy45Mmg0LjQ0bC01LjE3LTYuODYgNS4xNy02Ljg0bTI3LjMgMGwtMy40NCA4LjcyLTMuNDQtOC43Mkg1Ny42bDUuNDIgMTMuN2gzLjkybDUuNDItMTMuN2gtMy45NG0tMTUuNzUgMTMuN2gzLjk0VjkuNzhoLTMuOTR2MTMuN3ptMC0xNC42OGgzLjk0VjQuODloLTMuOTRWOC44eiIvPjxwYXRoIGQ9Ik0yMC42NyAxMi43MmEzLjEgMy4xIDAgMCAxIDIuNzQgMi40NWgtNS40OGEzLjA5IDMuMDkgMCAwIDEgMi43NC0yLjQ1em0wIDcuODJhMy4xIDMuMSAwIDAgMS0yLjc0LTIuNDVoOS40OGE2LjkgNi45IDAgMSAwLTYuNzQgNS4zOWg0LjY3bDIuMjEtMi45NHptNTUuNDMtMi40Mkg4MXYyLjQ1aC00LjdhLjg3Ljg3IDAgMCAxLS4yMSAwIDEuMjMgMS4yMyAwIDAgMS0xLTEuMTkgMS4yMSAxLjIxIDAgMCAxIDEuMDEtMS4yNnptNC40Mi04LjM0aC03LjE4bC0xLjE2IDIuOTRoNy4zNUExLjQ3IDEuNDcgMCAwIDEgODEgMTQuMTl2MWgtNS45YTQuMTUgNC4xNSAwIDAgMCAwIDguM0g4NXYtOS4zYTQuNDMgNC40MyAwIDAgMC00LjQ4LTQuNDF6IiBmaWxsPSIjZmZmZmZlIi8+PC9zdmc+"
              alt="Home"
            />
          </a>
          <div className="nx-popover-target nx-popover-click-outside-ignore8">
            <div className="nx-side-nav__section nx-side-nav__appsection">
              <div className="nx-accordion-item">
                <div className="nx-accordion-item__main">
                  <a className="nx-accordion-item__heading" tabIndex="0">
                    <div className="nx-accordion-item__label-icon">
                      <img
                        className="nx-accordion-item__icon"
                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ijc3ODUgMTE4MTkgMTkgMTkiPjxkZWZzPjxzdHlsZT4uY2xzLTJ7ZmlsbDojZmZmfTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJpY19OZXh0aXZhQXBwbGljYXRpb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc1MzkgMTE4MDMpIj48cmVjdCBpZD0iUmVjdGFuZ2xlXzc3NiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzc2IiB3aWR0aD0iNSIgaGVpZ2h0PSI1IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQ2IDE2KSIgZmlsbD0iI2Y1YjExYSIvPjxyZWN0IGlkPSJSZWN0YW5nbGVfNzc5IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3NzkiIGNsYXNzPSJjbHMtMiIgd2lkdGg9IjUiIGhlaWdodD0iNSIgcng9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0NiAyMykiLz48cmVjdCBpZD0iUmVjdGFuZ2xlXzc4MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzgzIiBjbGFzcz0iY2xzLTIiIHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDYgMzApIi8+PHJlY3QgaWQ9IlJlY3RhbmdsZV83NzciIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDc3NyIgY2xhc3M9ImNscy0yIiB3aWR0aD0iNSIgaGVpZ2h0PSI1IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUzIDE2KSIvPjxyZWN0IGlkPSJSZWN0YW5nbGVfNzgwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3ODAiIGNsYXNzPSJjbHMtMiIgd2lkdGg9IjUiIGhlaWdodD0iNSIgcng9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2MCAxNikiLz48cmVjdCBpZD0iUmVjdGFuZ2xlXzc3OCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzc4IiBjbGFzcz0iY2xzLTIiIHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNTMgMjMpIi8+PHJlY3QgaWQ9IlJlY3RhbmdsZV83ODQiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDc4NCIgd2lkdGg9IjUiIGhlaWdodD0iNSIgcng9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MyAzMCkiIG9wYWNpdHk9Ii43NDciIGZpbGw9IiNmZmYiLz48cmVjdCBpZD0iUmVjdGFuZ2xlXzc4MSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzgxIiB3aWR0aD0iNSIgaGVpZ2h0PSI1IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYwIDIzKSIgb3BhY2l0eT0iLjc0OSIgZmlsbD0iI2ZmZiIvPjxyZWN0IGlkPSJSZWN0YW5nbGVfNzgyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3ODIiIHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNjAgMzApIiBvcGFjaXR5PSIuNDk5IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg=="
                        alt=""
                      />
                    </div>
                    <div className="nx-side-nav__link nx-side-nav__applications">
                      Applications
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <dl
            id="nx-accordion-7u1w83mil"
            role="presentation"
            className="nx-accordion nx-side-nav__accordion nx-side-nav__content"
          >
            <div className="nx-side-nav__scrollbar nx-scrollbar ps">
              <dl
                id="nx-accordion-2qcie3099"
                role="presentation"
                className="nx-accordion nx-side-nav__accordion"
              >
                <div className="nx-side-nav__section">
                  <EntitiesList
                    openItems={params.type === 'ticket' ? { 0: true } : {}}
                    selectedItemId={selectedItemId}
                    items={this.props.tickets}
                    titleKey="subject"
                    heading="Tickets"
                    onClick={this.props.fetchAllTickets}
                    onItemClick={item => this.props.handleItemClick(item)}
                  />
                  <EntitiesList
                    openItems={params.type === 'sale' ? { 0: true } : {}}
                    selectedItemId={selectedItemId}
                    items={this.props.sales}
                    titleKey="name"
                    heading="Sales"
                    onClick={this.props.fetchAllSales}
                    onItemClick={item => this.props.handleItemClick(item)}
                  />
                </div>
              </dl>
              <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                <div
                  className="ps__thumb-x"
                  tabIndex="0"
                  style={{ left: 0, width: 0 }}
                />
              </div>
              <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                <div
                  className="ps__thumb-y"
                  tabIndex="0"
                  style={{ top: 0, height: 0 }}
                />
              </div>
            </div>
          </dl>
        </div>
      </aside>
    );
  }
}

SideNav.propTypes = {
  selectedItems: PropTypes.object,
  selectedItem: PropTypes.object,
  sales: PropTypes.object,
  tickets: PropTypes.object,
  handleItemClick: PropTypes.func.isRequired,
  fetchAllTickets: PropTypes.func.isRequired,
  fetchAllSales: PropTypes.func.isRequired,
  fetchTicketsById: PropTypes.func.isRequired,
  fetchSalesById: PropTypes.func.isRequired,
};
